export default __webpack_public_path__ + "static/media/na.e335bb35.svg";